module.exports = __webpack_public_path__ + "static/img/punch-about.0109413.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/Agree/img/desc/punch-about.png
// module id = 163
// module chunks = 0